// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import { Menu } from "semantic-ui-react";
import "./ApplicationLauncherMenuAction.less";
import { getApplicationClassName } from "../utils/className";
import { jsx as _jsx } from "react/jsx-runtime";
const className = getApplicationClassName("launcher", "menu", "action");

// eslint-disable-next-line max-len

export const ApplicationLauncherMenuAction = props => {
  const {
    icon,
    content,
    onClick
  } = props;
  const handleClick = React.useCallback(event => {
    onClick?.(event, props);
  }, [onClick, props]);
  return React.useMemo(() => /*#__PURE__*/_jsx(Menu.Item, {
    className: className,
    icon: icon,
    content: content,
    onClick: handleClick
  }), [icon, content, handleClick]);
};